export default "__VITE_ASSET__CARm90CQ__"